<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-battery`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 10a2 2 0 00-2-2H4a2 2 0 00-2 2v28a2 2 0 002 2h36a2 2 0 002-2v-6h3a1 1 0 001-1V17a1 1 0 00-1-1h-3v-6zM6 12h32v24H6V12zm10 4a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V17a1 1 0 011-1h2zm11 1a1 1 0 00-1-1h-2a1 1 0 00-1 1v14a1 1 0 001 1h2a1 1 0 001-1V17z"/></svg>
</template>
<script>

export default {
  name: 'IconBattery',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
